import React from "react"

import { NotificationManager } from "react-notifications"

import { gql, useMutation, useQuery } from "hooks/urql"

import UrqlLoadingIndicator from "components/WithLoadingIndicator/urql"

const TeacherAudioRoom: React.FC<{ teacherId: string }> = ({ teacherId }) => {
  const [result] = useQuery({
    query: teacherAudioRoomQuery,
    variables: { teacherId },
  })
  const [mutationState, runMutation]: any[] = useMutation(
    createAudioRoomForTeacherMutation
  )

  const handleCreate = () => {
    runMutation({ teacherId })
      .then(result => {
        const { failures } = result.data.createAudioRoomForTeacher
        if (failures.length > 0) NotificationManager.error(failures[0].message)
        else window.location.reload()
      })
      .catch(e => NotificationManager.error(e.message))
  }

  return (
    <>
      <h4 className="my-0">Audio Room</h4>
      <UrqlLoadingIndicator result={result}>
        {({ data }) =>
          data.teacher.audioRoom ? (
            <a
              href={data.teacher.audioRoom.showPath}
              className="btn btn-info"
              target="_blank"
              rel="noopener noreferrer"
            >
              Join Audio Room
            </a>
          ) : (
            <button
              className="btn btn-success"
              onClick={handleCreate}
              disabled={mutationState.fetching}
            >
              Create Audio Room
            </button>
          )
        }
      </UrqlLoadingIndicator>
    </>
  )
}

const teacherAudioRoomQuery = gql`
  query AdminTeacherAudioRoom($teacherId: ID!) {
    teacher(id: $teacherId) {
      audioRoom {
        showPath
      }
    }
  }
`

const createAudioRoomForTeacherMutation = gql`
  mutation CreateAudioRoomForTeacher($teacherId: ID!) {
    createAudioRoomForTeacher(teacherId: $teacherId) {
      failures {
        message
      }
    }
  }
`

export default TeacherAudioRoom
